import { AccountLevel, UserListResponse } from '../models/admin';
import { deleteData, getData, postData, putData } from './api';
import { ApiEmptyResponse, ResponseData } from './models';

export const listUsers = async (): Promise<ResponseData<UserListResponse>> =>
  getData<UserListResponse>('api/admin/users');

export const remove = async (
  userId: string
): Promise<ResponseData<ApiEmptyResponse>> =>
  deleteData(`api/admin/users/${userId}`);

export const block = async (
  userId: string
): Promise<ResponseData<ApiEmptyResponse>> =>
  postData(`api/admin/users/${userId}/block`, {});

export const unblock = async (
  userId: string
): Promise<ResponseData<ApiEmptyResponse>> =>
  postData(`api/admin/users/${userId}/unblock`, {});

export const updateAccount = async (
  userId: string,
  account: AccountLevel
): Promise<ResponseData<ApiEmptyResponse>> =>
  putData(`api/admin/users/${userId}/account`, { accountLevel: account });
